<template>
<div>
  <Head :active="'policies'"></Head>
  <banner />
<div class="join">
  <div class="container">
    <div :class="{list:true,lister:listshow}">
      <span class="title">
        <div class="spanx" style="background-image: linear-gradient(135deg, #82d269, #0ca8ac, #1e7ec7);"></div>
        {{titles.ABOUT_TITLE}}
        <div class="spanx" style="background-image: linear-gradient(135deg, #1e7ec7, #0ca8ac, #82d269);"></div>
      </span>
      <div class="text">
         {{titles.ABOUT_TITLETEXT}}
      </div>
      <!-- <div class="corner">
      </div> -->
    </div>
    <div :class="{jointext:true,jointexter:jointextershow}">
      <p>{{titles.ABOUT_A}}</p>
        <br>
      <p>{{titles.ABOUT_B}}</p>
        <br>
      <p>{{titles.ABOUT_C}}</p>
        <br>
      <p>{{titles.ABOUT_D}}</p>
        <br>
      <p>{{titles.ABOUT_E}}</p>
        <br>
      <p>{{titles.ABOUT_F}}</p>
        <br>
    </div>
    <div :class="{list:true,lister:listoneshow}">
      <span class="title">
        <div class="spanx" style="background-image: linear-gradient(135deg, #82d269, #0ca8ac, #1e7ec7);"></div>
        {{titles.ABOUT_TITLEONE}}
        <div class="spanx" style="background-image: linear-gradient(135deg, #1e7ec7, #0ca8ac, #82d269);"></div>
      </span>
      <div class="text">
        {{titles.ABOUT_TITLEONETEXT}}
      </div>
    </div>
      <div class="container-item">
        <div v-for="(art, idx) in about" :key="'ABOUT_IMG'+idx" :class="{itemo:true,itemoer:itemoershow}" rel="nofollow">
          <!-- <a class="" target="_blank" href=""> -->
            <div
              class="itemo-color">
              <img style="height:170px;width:170px;border-radius:50%;margin-top:6px;" :src="art.img" />
              <!-- <div class="one">SEO</div> -->
            </div>
                <!-- <div style="width:100%;height:auto;text-align:center;margin-top:-45px;">
                  <img style="height:90px;width:90px;" src="https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/hankong/05.png" />
                </div> -->
                <div class="two">
                <p style="font-size:22px">
                <!-- <p v-for="(twocon, idx) in twocons" :key="idx"> -->
                  {{art.title}}
                </p>
                <span style="line-height:0px; font-size:14px; color:#999">{{art.con}}</span>
                <!-- <div class="button">了解详情</div> -->
                </div>
          <!-- </a> -->
        </div>
      </div>
    </div>
</div>
<Footer />
</div>
</template>

<script>
import axios from 'axios'
import Head from '../../components/header.vue'
import banner from '../../components/banner.vue'
import Footer from '../../components/footer.vue'
export default {
  components: {
    Head,
    banner,
    Footer
  },
  data () {
    return {
      listshow: true,
      jointextershow: false,
      listoneshow: false,
      itemoershow: false,
      about: [],
      titles: []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        // this.center = response.data.CENTER
        this.about = response.data.ABOUT.ABOUT_CONTER
        this.titles = response.data.ABOUT
        // this.twocons = response.data.CENTER.CONTER_TWO
        // console.log(this.about)
      })
  },
  methods: {
    handleScroll () {
      // console.log(this.currentScroll)
      // this.currentScroll = window.innerHeight
      this.currentScroll = window.pageYOffset
      // console.log(this.innerHeight)
      // console.log(window.pageYOffset, this.currentScroll)
      if (this.currentScroll >= 300) {
        // console.log(this.currentScroll)
        this.jointextershow = true
      }
      if (this.currentScroll >= 700) {
        this.listoneshow = true
      }
      if (this.currentScroll >= 800) {
        this.itemoershow = true
      }
    }
  }
  // },
  // methods: {
  //   more: function (event) {
  //     window.location.href = '#/scope'
  //   }
  // }
}
</script>

<style lang="less" scoped>
@import url('../../../static/less/less.css');
//>1100
// @keyframes fadeUp{
//   from {bottom: -30px;}
//   to {bottom: 0px;}
// }
// @keyframes fadeDown {
//   from {top: -40px;}
//   to {top: 0px;}
// }
@media only screen and (min-width: 960px) {
  .itemo {
    width: 23%;
    height: 310px;
    float: left;
    margin-right: 20px;
  }
  .container-item {
    display: inline-flex;
  }
  .title {
    font-size: 38px;
  }
  .text {
    font-size: 17px;
  }
  .spanx {
    width: 75px;
  }
}
@media only screen and (min-width: 767px) and (max-width: 960px) {
  .itemo {
    width: 45%;
    height: 310px;
    float: left;
    margin-right: 20px;
  }
  .title {
    font-size: 35px;
  }
  .text {
    font-size: 15px;
  }
  .spanx {
    width: 70px;
  }
  .container-item {
    display: inline-block;
  }
}
//<1100
@media only screen and (max-width: 767px) {
  .itemo {
    width: 250px;
    height: 310px;
    float: left;
    margin-right: 20px;
  }
  .title {
    font-size: 20px;
  }
  .spanx {
    width: 56px;
  }
  .text {
    font-size: 12px;
  }
  .container-item {
    display: inline-block;
  }
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #2ec4b6;
}
.join {
  padding: 100px 0 0 0;
  margin-top: 20px;
  // background-color: #1c85f3;
  // background: url();
  // text-align: center;
  // min-width: 1200px;
}
.demo {
  text-align: center;
  margin: 20px;
}
.buttondemo {
  background-color: #2ec4b6;
  width: 120px;
  height: 35px;
  border: none;
  cursor: pointer;
  color: #fdfffc;
}
.container {
  width: 96%;
  // padding: 55px 10% 60px 10%;
  // background-color: #fdfffc;
  margin: 0 auto;
  max-width: 1200px;
  .lister {
    position: relative;
    animation-name: fadeUp;
    animation-duration: 1.5s;
    opacity: 1 !important;
  }
  .list {
    // position: relative;
    // animation-name: fadeUp;
    // animation-duration: 1.5s;
    opacity: 0;
    text-align: center;
    margin-bottom: 30px;
    .spanx {
    // border-top: 3px solid;
    // width: 75px;
    height: 3px;
    text-align: left;
    display: inline-block;
    margin: 0px 25px;
    // background-image: linear-gradient(135deg, #82d269, #0ca8ac, #1e7ec7);
    }
    .title {
      // font-size: 38px;
      color: #333;
    }
    .text {
      // font-size: 17px;
      color: #B9BABA;
      line-height: 20px;
    }
  }
  .jointexter {
    animation-name: fadeUp;
    visibility: visible;
    animation-duration: 3s;
    opacity: 1 !important;
  }
  .jointext {
    opacity: 0;
    word-break: break-word;
    color: #666666;
    line-height: 28px;
    margin: 15px auto 80px;
    }
  .corner {
    // padding-top: 10px;
    margin: 15px auto;
    width: 0;
    height: 0;
    border: 10px solid #ff9f1c;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  &-item {
    // margin: 0px 5%;
    clear: both;
    width: 100%;
    // display: flex;
    // height: auto;
    padding: 40px 0 22px;
    margin: 0 auto;
    // display: flow-root;
    .itemoer {
      // transform: translateY(0%) !important;
      position: relative;
      animation-name: FadeUpone;
      animation-duration: 1.5s;
      opacity: 1 !important;
      }
    .itemo {
      // position: relative;
      // animation-name: fadeDown;
      // animation-duration: 2s;
      // margin-top: 20px;
      // width: 350px;
      // height: 310px;
      // float: left;
      margin-top: 20px;
      position: relative;
      // transition: all 0.3s;
      // border: 1px solid #e5e5e5;
      box-sizing: border-box;
      text-align: center;
      transform: translateY(-20%);
      opacity: 0;
      width: 100%;
      height: 310px;
      a {
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        transition: none;
        // color: #333;
      }
      a:hover {
        border: 1px solid #26bbfb;
      }
      .itemo-color {
        height: 60%;
        width: 185px;
        // height: 185px;
        line-height: 185px;
        text-align: center;
        margin: 0 auto;
        border: 1px dashed #B9BABA;
        border-radius: 50%;
        // background-color: #eee;
        // height: 60%;
      }
      .one {
        width: 100%;
        height: 155px;
        background: rgba(116, 116, 156, 1.7);
        // background-size: cover;
        // background-position: center;
        padding-top: 45px;
        font-size: 24px;
        color: #011627;
        text-align: center;
        box-sizing: border-box;
      }
      .two {
        font-size: 16px;
        line-height: 45px;
        margin-top: 36px;
        // height: 95px;
        color: #011627;
        height: 40%;
        // padding: 0 10% 0 10%;
        // background-color: lavender;
      }
      .button {
        font-size: 14px;
        // padding: 10px 0 10px 0;
        display: block;
        width: 105px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        border-radius: 15px;
        background: #26bbfb;
        margin: 0 auto;
        margin-top: 20px;
        // font-size: 13px;
        // margin-top: 30px;
        // background-color: lavender;
        // padding: 10px 0 10px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue